export const SHOW_LOGIN_POPUP = 'showLoginPopup'
export const HIDE_LOGIN_POPUP = 'hideLoginPopup'
